import {combineReducers} from 'redux'
import {sideMenuReducer} from './side-menu-reducer'
import {isLoginReducer} from './is-login-reducer'
import {profileReducer} from './profile-reducer'
import {toolbarTitleReducer} from './toolbar-title-reducer'

const reducers = combineReducers({
    login: isLoginReducer,
    profile: profileReducer,
    sideMenu: sideMenuReducer,
    toolbar: toolbarTitleReducer
})

export default reducers;